import React from 'react';
import { Popover, PopoverProps } from '@mui/material';

const MenuPopover = ({ children, sx, ...other }: PopoverProps) => {
  return (
    <Popover
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      PaperProps={{
        sx: {
          mt: 1.5,
          ml: 0.5,
          width: 200,
          boxShadow: '0px 1px 12px 0px rgba(141, 156, 174, 0.25)',
          ...sx
        }
      }}
      {...other}
    >
      {children}
    </Popover>
  );
};

export default MenuPopover;
